'use strict';
import React, {Component} from 'react';
import ReactPlayer from 'react-player'

export default class BackgroundVid extends Component {
 	constructor(){
 		super();
 		this.state = {
 			showVid: true,
 			firstLoad: true,
 		};
 	}
	// this.show_vid = true;
 	showVid(){
 		// console.log("show vid");
 		if(this.state.firstLoad) var time = 0
 		else var time = 0;

 		setTimeout(() => {this.setState({ showVid: false })},time)
 		this.state.firstLoad = false;
 	}
 	hideVid(){
 		// console.log("hide vid");
 		this.setState({ showVid: true })
 	}

    render() {
    	const {showVid}  = this.state;
        // const youtubeConfig = "&vq=hd720";//{playerVars:"&vq=hd720" };

        return (
        	<div className="main_page_vid hide_overflow" >
                <div className="hidden-xs vid_wrap hide_overflow">
                  <ReactPlayer className="hide_overflow" width="100%" height="100%" vimeoConfig={{iframeParams:{autoplay:1, loop:1}}} 
                  url='https://vimeo.com/191932687' onEnded={this.hideVid.bind(this)} onPlay={this.showVid.bind(this)} hidden={showVid} loop={true} playing />


                </div>
        	</div>
        )

    }
}
                    // youtube via reactPlayer

                    // <ReactPlayer className="hide_overflow" width="100%" height="100%" youtubeConfig={{playerVars:{VQ:"hd720"}}} url='https://www.youtube.com/embed/WnV7EmbfYvM' onEnded={this.hideVid.bind(this)} onPlay={this.showVid.bind(this)} hidden={showVid} loop={true} playing />      

                    // react
                    // <video width="100%" height="100%" muted autoPlay loop>
                    // <source src="/react-app/vid/blue.mp4" type="video/mp4"></source>
                  // </video>



// WEBPACK FOOTER //
// ./src/js/components/BackgroundVid.js